import { inject, Injectable, Injector, Provider } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth.service';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getAuth, getIdToken } from '@angular/fire/auth';

export const tokenInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

    const bypass_list = ['oauthCallback', 'recaptcha/assessment', 'api/v1/load-published-data', 'getSubscriptionPlans/', 'rsvp']; // 'api/app/get-recaptcha-response', 
    const bypass_partial = [new RegExp("api/v1/"), new RegExp("assets/")] // if any of these partial strings are found in the url, the token will not be added.  This is for urls that have dynamic components (like eventId) that make it hard to list out the full url in the bypass_list
    // console.log('intercepting request',environment.functionsURL, request.url.replace(environment.functionsURL, ''))
    if (bypass_list.indexOf(request.url.replace(environment.functionsURL, '')) > -1
        || bypass_partial.some(partial => request.url.match(partial))
    ) { //
        // console.log('bypassing token interceptor for url', request.url)
        return next(request);
    }

    const auth = inject(AuthService); // inject the authservice manually (see 
    return from(getIdToken(getAuth().currentUser)).pipe(
        switchMap(token => {
             request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
            return next(request);
        })
    );
} 


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    auth: AuthService;
    bypass_list = ['oauthCallback', 'getSubscriptionPlans/', 'rsvp'];

    constructor(private inj: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.bypass_list.indexOf(request.url.replace(environment.functionsURL + '/', '')) > -1) {
            return next.handle(request);
        }

        this.auth = this.inj.get(AuthService); // inject the authservice manually (see https://github.com/angular/angular/issues/18224)

        return from(getIdToken(getAuth().currentUser)).pipe(
            switchMap(token => {
                 request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
                return next.handle(request);
            })
        );
    }
}